import React from 'react'
import CollectionGallery from '../components/CollectionGallery'

const GirlsCollection: React.FC = () => {
  return <CollectionGallery collection="girls" />
}

export default GirlsCollection
